import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { actionCreators } from '@/store/myTasks'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import LoadingIndicator from '@/components/LoadingIndicator'
import Resx from '@/components/Resx'
import { Main, MainBody, MainTop, MainTopLeft, MainTopTitle } from '@/components/Layout'
import { TaskResponseButtons } from '@/internal-app/pages/tasks/responseButtons'
import TaskDetailForm from './detailForm'
import { useDispatch } from '@/hooks/dispatch'

const TaskDetail = React.memo(function TaskDetail (props) {
  const { retrieving, task, detailComponentKey } = useSelector(state => state.myTasks)
  const activeTaskId = useSelector(state => state.myActiveTask.activeTask && state.myActiveTask.activeTask.id)

  const [getMyTask, updateDescription, openDialog] = useDispatch([actionCreators.getMyTask, actionCreators.updateDescription, dialogActions.openDialog])

  useEffect(() => {
    getMyTask(props.match.params.id)
  }, [getMyTask, props])

  const onEditDescriptionButtonClick = (lang, title) => {
    const propName = (lang === 'ar' ? 'description' : 'latinDescription')
    const text = task[propName]
    openDialog({
      dialogType: dialogTypes.editPlainText,
      localizedTitle: title,
      text,
      onAction: (updatedText) => {
        const { id, description, latinDescription } = task
        const dto = { id, description, latinDescription }
        dto[propName] = updatedText
        updateDescription(dto)
      }
    })
  }

  const renderContent = () => {
    if (retrieving === true || !task) {
      return <LoadingIndicator />
    }
    return (
      <div>
        <TaskDetailForm
          key={detailComponentKey}
          task={task}
          {...props}
          onEditDescriptionButtonClick={onEditDescriptionButtonClick}
        />
      </div>
    )
  }

  return (
    <Main path={[task && { text: '#' + task.id, localized: true }]}>
      <MainTop>
        <MainTopTitle backUrl={props.isAllTasks ? '/all-tasks' : '/tasks'}>
          <Resx name='Tasks.Task' />
        </MainTopTitle>
        <MainTopLeft>
          {task &&
            <TaskResponseButtons useActiveTask={false} task={task} disabled={!(task && task.id === activeTaskId)} />}
        </MainTopLeft>
      </MainTop>
      <MainBody transparent>
        {renderContent()}
      </MainBody>
    </Main>
  )
})

export default TaskDetail



// WEBPACK FOOTER //
// ./src/internal-app/pages/tasks/taskDetail.js